import React, { createContext, ReactNode, useContext, useState } from 'react';
import Modal from './components/modal';

export interface ModalContextProps {
  show: (content: ReactNode) => void;
  close: () => void;
  modal: React.ReactNode;
  isVisible: boolean;
}

export const ModalContext = createContext<ModalContextProps>({
  show: () => {},
  close: () => {},
  modal: <div />,
  isVisible: false
});

export function ModalContextProvider({ children }: { children: ReactNode }) {
  const [isVisible, setIsVisible] = useState(false);
  const [content, setContent] = useState<ReactNode>(<div />);
  const value = {
    show,
    close,
    modal: <Modal>{content}</Modal>,
    isVisible
  };

  return <ModalContext.Provider value={value}>{children}</ModalContext.Provider>;

  function show(content: ReactNode) {
    setContent(content);
    setIsVisible(true);
  }

  function close() {
    setIsVisible(false);
  }
}

export default function useModal() {
  const { show, close, modal, isVisible } = useContext<ModalContextProps>(ModalContext);
  return {
    show,
    close,
    modal,
    isVisible
  };
}
